const TEMPLATE_NAME = 'SEARCH_ADDRESS';

const initialState = () => ({
    searching: false,
    searched: false,
    address: {},
    notFound: false
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                searching: true,
                searched: true
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                address: {},
                searching: false,
                notFound: true
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = action.payload;
            return {
                ...state,
                searching: false,
                address: data

            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};

export default reducer;